import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import api from "../../api";
import { Box } from "@material-ui/core";
import TimeSeriesUps from "../TimeSeriesUps.js";
import TimeSeriesUpsStatic from "../TimeSeriesUpsStatic";
import TimeSeries1 from "../TimeS";
// import TimeSeries2 from "../TimeC";

import {
  Grid,
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Card,
} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Ups from "../../assets/img/ups_1.png";
import Success from "components/Typography/Success";
import Danger from "components/Typography/Danger";
import SemiCircleProgressBar from "react-progressbar-semicircle";
import { useSelector } from "react-redux";
import { ThemeProvider } from "@material-ui/core/styles";
import theme from "../../responsive/TextTypography";

import { blackColor, hexToRgb } from "assets/jss/material-dashboard-react.js";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "-1vh",
  },
  paper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    padding: theme.spacing(1),
    textAlign: "center",
    // color: theme.palette.text.secondary,
    // boxShadow: '0px 4px 20px #0123B41A',
    // backgroundColor: 'white',
    // borderRadius: '14px',
    borderRadius: "6px",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    height: "10vh",
    marginTop: "1vh",
    opacity: "1",
  },
  formControl: {
    autosize: true,
    clearable: false,
  },
  CardbodyInsideGrid: {
    "justify-content": "center",
    display: "inline-flex",
    padding: "0.9375rem 20px",
    flex: "1 1 auto",
    WebkitBoxFlex: "1",
    position: "relative",
  },
  select: {
    "&:after": {
      borderBottomColor: "blue",
    },
    "& .MuiSvgIcon-root": {
      color: "white",
      backgroundColor: "#0123b4",
      borderRadius: "8px",
    },
    "& .MuiSelect-root ": {
      marginTop: "-2vh",
    },
  },
  graphpaper: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    borderRadius: "6px",
    boxShadow: "1px 0px 8px 2px rgba(0, 0, 0, 0.14)",
    backgroundColor: "#fcfafa",
    height: "26vh",
    textAlign: "center",
    color: theme.palette.text.secondary,
    // boxShadow: '0px 4px 20px #0123B41A',
    // borderRadius: '14px',
  },
  semicircularbarFont: {
    "@media (min-width:0px) and (max-width:599.95px)": {
      //xs
      "& .semicircle-percent-value": {
        fontSize: "1.4vh",
        color: "grey",
      },
    },
    "@media (min-width:600px) and (max-width:959.95px)": {
      //sm
      "& .semicircle-percent-value": {
        fontSize: "1vh",
        color: "grey",
      },
    },
    "@media (min-width:960px) and (max-width:1279.95px)": {
      //md
      "& .semicircle-percent-value": {
        fontSize: "1.7vh",
        color: "grey",
      },
    },
    "@media (min-width:1280px) and (max-width:1919.95px)": {
      //lg
      "& .semicircle-percent-value": {
        fontSize: "1vh",
        color: "grey",
      },
    },
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      //xl
      "& .semicircle-percent-value": {
        fontSize: "1.2vh",
        color: "grey",
      },
    },
  },
  semicircularbar: {
    "@media (min-width:0px) and (max-width:599.95px)": {
      //xs
      marginTop: "-0.5vh",
      marginLeft: "-1.5vh",
    },
    "@media (min-width:600px) and (max-width:959.95px)": {
      //sm
      marginTop: "-1vh",
      marginLeft: "-0.1vh",
    },
    "@media (min-width:960px) and (max-width:1279.95px)": {
      //md
      marginTop: "-2vh",
      marginLeft: "-0.1vh",
    },
    "@media (min-width:1280px) and (max-width:1919.95px)": {
      //lg
      // marginTop:'-2vh',
      marginLeft: "-3.1vh",
    },
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      //xl
      marginTop: "-1vh",
      marginLeft: "0.5vh",
    },
  },
  alarms: {
    fontSize: "2.5vh",
    color: "#4caf50",
  },
  statusFont: {
    fontWeight: "bold",
    "@media (min-width:0px) and (max-width:599.95px)": {
      //xs
      textAlign: "center",
      fontSize: "1.5vh",
      color: "#292929",
    },
    "@media (min-width:600px) and (max-width:959.95px)": {
      //sm
      textAlign: "center",
      fontSize: "1.3vh",
      color: "#292929",
    },
    "@media (min-width:960px) and (max-width:1279.95px)": {
      //md
      textAlign: "center",
      fontSize: "1.3vh",
      color: "#292929",
    },
    "@media (min-width:1280px) and (max-width:1919.95px)": {
      //lg
      textAlign: "center",
      fontSize: "1.7vh",
      whiteSpace: "nowrap",
      color: "#292929",
    },
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      //xl
      textAlign: "center",
      fontSize: "1.7vh",
      color: "#292929",
      whiteSpace: "nowrap",
    },
  },
  card1: {
    "@media (min-width:0px) and (max-width:599.95px)": {
      //xs
      height: "26.5vh",
    },
    "@media (min-width:600px) and (max-width:959.95px)": {
      //sm
      height: "28vh",
    },
    "@media (min-width:960px) and (max-width:1279.95px)": {
      //md
      height: "14vh",
    },
    "@media (min-width:1280px) and (max-width:1919.95px)": {
      //lg
      height: "14vh",
    },
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      //xl
      height: "14vh",
    },
  },
  image: {
    "@media (min-width:0px) and (max-width:599.95px)": {
      //xs
      marginLeft: "-4vh",
    },
    "@media (min-width:600px) and (max-width:959.95px)": {
      //sm
      marginLeft: "-9vh",
    },
    "@media (min-width:960px) and (max-width:1279.95px)": {
      //md
      marginLeft: "-7.5vh",
    },
    "@media (min-width:1280px) and (max-width:1919.95px)": {
      //lg
      marginLeft: "-4vh",
    },
    "@media (min-width:1920px) and (max-width:2559.95px)": {
      //xl
    },
  },
}));

const getMyValue = (input, params = []) => {
  let test = -1;
  try {
    if (input !== undefined) test = input[params[0]];
    else return;
    if (test !== undefined) {
      for (let i = 1; i < params.length; i++) {
        if (params[i] !== undefined) test = test[params[i]];
        else break;
      }
    }
  } catch (e) {
    console.log("My Error in getMyValue: ", e.message);
  }
  return test;
};

export default function GlUps(props) {
  const classes = useStyles();
  // const zone_data = useSelector((state) => state.inDashboard.locationData);
  // const [fid, setFId] = useState("");
  // const buildingID = useSelector((state) => state.isLogged.data.building.id);
  // const [fdata, setFdata] = useState(localStorage.getItem("floorName"));
  const initialState =
    props.location.state != null ? props.location.state.dev_name : "UPS-1";
  // const initialState = props.location.state != null ? props.location.state.name : "UPS-1";
  const [data, setData] = useState(initialState);
  const initialState1 =
    props.location.state != null
      ? props.location.state.dev_id
      : "8ee50faf-4f7e-11ed-9ab5-9829a659bba7";
  console.log("initial----------------", initialState1);
  // const initialState1 = '8ee50faf-4f7e-11ed-9ab5-9829a659bba7';
  const [upsdevice, setUpsdevice] = useState([]);
  const [deviceid, setDeviceid] = useState(initialState1);
  const [ups1, setUps1] = useState([]);
  const [openerr, setOpenerr] = React.useState(false);
  const [errmsg, setErrmsg] = React.useState("");
  const [value2, setValue2] = useState([]);

  const [value3, setValue3] = useState([]);
  const [value4, setValue4] = useState([]);
  const [value5, setValue5] = useState([]);
  const [value6, setValue6] = useState([]);
  const [value7, setValue7] = useState([]);
  const [value8, setValue8] = useState([]);
  const [value9, setValue9] = useState([]);
  const [value10, setValue10] = useState([]);
  const [value11, setValue11] = useState([]);
  const [value12, setValue12] = useState([]);
  const [value13, setValue13] = useState([]);
  const [value14, setValue14] = useState([]);
  const [value15, setValue15] = useState([]);
  const [value16, setValue16] = useState([]);
  const [value17, setValue17] = useState([]);
  const [value18, setValue18] = useState([]);
  const [value19, setValue19] = useState([]);
  const [value20, setValue20] = useState([]);
  const [value21, setValue21] = useState([]);
  const [outputvoltA, setOuputvoltA] = useState([]);
  const [outputvoltB, setOuputvoltB] = useState([]);
  const [outputvoltC, setOuputvoltC] = useState([]);
  const [outputcurrA, setOuputcurrA] = useState([]);
  const [outputcurrB, setOuputcurrB] = useState([]);
  const [outputcurrC, setOuputcurrC] = useState([]);

  const [upsdata2, setUpsdata2] = useState([]);

  const [equipmentData, setEquipmentData] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [fdata, setFdata] = useState("");
  const zone_data = useSelector((state) => state.inDashboard.locationData);
  const [fid, setFId] = useState("");
  const [floor, setFloor] = useState([]);
  const buildingID = useSelector((state) => state.isLogged.data.building.id);
  // const [dcInputBatteryVoltage, setDCInputBatteryVoltage] = useState("");
  const [voltR, setVoltR] = useState(null);
  const [voltY, setVoltY] = useState(null);
  const [voltB, setVoltB] = useState(null);
  const [selectedDevData, setSelecteDevData] = useState({});
  const handleDeviceChange = (name, id, data) => {
    console.log("Floor change:", id, name);
    setFId(id);
    setFdata(name);
    setSelectedDevice(id);
    setSelecteDevData(data);
  };
  // const getUPSValue = (param) => {
  //   const val = selectedDevData?.Eqp_Attributes?.[param]?.presentValue;
  //   return val != null && !isNaN(val) ? Number(val).toFixed(2) : "";
  // };
  const getUPSValue = (key) => {
    const value = selectedDevData?.Eqp_Attributes?.[key]?.presentValue;

    if (value == null) return " ";

    return (Number(value) / 10).toFixed(2);
  };

  useEffect(() => {
    if (equipmentData && equipmentData.length > 0) {
      const firstDevice = equipmentData[0];
      setFdata(firstDevice.name);
      handleDeviceChange(firstDevice.name, firstDevice.id, firstDevice);
    }
  }, [equipmentData]);

  
  useEffect(() => {
    api.floor.cpmGetDevData().then((res) => {
      console.log("Full API response:", res);

      // ✅ extract only UPS-related data
      const upsData = res?.["NONGL_SS_UPS_1PHASE"] || null;

      if (upsData) {
        console.log("UPS data:", Object.values(upsData));
        setEquipmentData(Object.values(upsData));
      } else {
        console.warn("UPS data not found in API response");
        setEquipmentData({});
      }

      setSelectedDevice("");
      const firstUps = Object.values(upsData)[0];
      if (firstUps) {
        // Extract R/Y/B voltages safely
        const rVolt =
          firstUps["UPS_INPUT_V_R_Phase"]?.presentValue ||
          firstUps["UPS_O/P_V_R_Phase"]?.presentValue ||
          firstUps["UPS_INPUT_V_R_Phases"]?.presentValue ||
          null;

        const yVolt =
          firstUps["UPS_O/P_V_Y_Phase"]?.presentValue ||
          firstUps["UPS_INPUT_V_Y_Phase"]?.presentValue ||
          null;

        const bVolt =
          firstUps["UPS_O/P_V_B_Phase"]?.presentValue ||
          firstUps["UPS_INPUT_V_B_Phase"]?.presentValue ||
          firstUps["UPS_O/P_C_B_Phase"]?.presentValue ||
          null;

        // ✅ Save them to state
        setVoltR(rVolt);
        setVoltY(yVolt);
        setVoltB(bVolt);

        console.log("Extracted Voltages:", { rVolt, yVolt, bVolt });
      }
    });
  }, []);

  useEffect(() => {
    console.log("useffect calleddddddddddddddddddddddddd", deviceid);
    let zone_id = "",
      z_data = [];
    zone_data.sort(function (a, b) {
      return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
    });
    zone_data.filter((_each) => _each.zone_type === "GL_LOCATION_TYPE_FLOOR");
    // console.log("fdata in useee",fdata== null ? "it is null":"NAN")
    if (fdata !== null) {
      zone_data.filter((_each, i) => {
        if (
          _each.zone_type === "GL_LOCATION_TYPE_FLOOR" &&
          _each.name === fdata
        ) {
          return (zone_id = _each.uuid);
        }
      });
    } else {
      zone_data.filter((_each, i) => {
        if (_each.zone_type === "GL_LOCATION_TYPE_FLOOR") {
          z_data.push(_each);
        }
      });
      zone_id = z_data[0].uuid;
      setFdata(z_data[0].name);
      setFId(zone_id[0].uuid);
    }

    api.floor.devicemap(zone_id, "UPS").then((res) => {
      setUpsdevice(res);
      console.log(
        "device--------",
        deviceid,
        "data----------------------",
        data
      );
      if (deviceid == "" && data == "") {
        res.sort(function (a, b) {
          return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
        });
        setDeviceid(res[0]["ssid"]);
        setData(res[0]["name"]);
        api.floor.UpsData(res[0]["ssid"]).then((res) => {
          res.map((ele) => {
            if (ele.param_id == "input_ph_volt_A") {
              setValue2(ele.param_value);
            }
            if (ele.param_id == "input_ph_volt_B") {
              setValue3(ele.param_value);
            }
            if (ele.param_id == "input_ph_volt_C") {
              setValue4(ele.param_value);
            }
            if (ele.param_id == "ph_A_Out_acti_Pow ") {
              setValue5(ele.param_value);
            }
            if (ele.param_id == "ph_B_Out_acti_Pow ") {
              setValue6(ele.param_value);
            }
            if (ele.param_id == "ph_C_Out_acti_Pow") {
              setValue7(ele.param_value);
            }
            if (ele.param_id == "kW") {
              setValue8(ele.param_value);
            }
            if (ele.param_id == "output_ph_curr_A") {
              setValue9(ele.param_value);
            }
            if (ele.param_id == "output_ph_curr_B") {
              setValue10(ele.param_value);
            }
            if (ele.param_id == "output_ph_curr_C") {
              setValue11(ele.param_value);
            }
            if (ele.param_id == "output_ph_volt_A") {
              setValue12(ele.param_value);
            }
            if (ele.param_id == "output_ph_volt_B") {
              setValue13(ele.param_value);
            }
            if (ele.param_id == "output_ph_volt_C") {
              setValue14(ele.param_value);
            }
            if (ele.param_id == "out_freqphase_A") {
              setValue15(ele.param_value);
            }
            if (ele.param_id == "out_freqphase_B") {
              setValue16(ele.param_value);
            }
            if (ele.param_id == "out_freqphase_C") {
              setValue17(ele.param_value);
            }
            if (ele.param_id == "input_freq") {
              setValue18(ele.param_value);
            }
            if (ele.param_id == "vbat") {
              setValue19(ele.param_value);
            }
            if (ele.param_id == "PF") {
              setValue20(ele.param_value);
            }
            if (ele.param_id == "Runtime") {
              setValue21(ele.param_value);
            }
            setUpsdata2(res);
          });
        });

        api.floor.UpsGraphData(res[0]["ssid"]).then((res) => {
          console.log("res----------------", res).then((res) => {
            if (res.graphData.length) {
              if (res.graphData[0]["output_ph_volt_A"]) {
                setOuputvoltA(
                  getMyValue(res, ["graphData", 0, "output_ph_volt_A"])
                );
              }
              if (res.graphData[0]["output_ph_volt_B"]) {
                setOuputvoltB(
                  getMyValue(res, ["graphData", 0, "output_ph_volt_B"])
                );
              }
              if (res.graphData[0]["output_ph_volt_C"]) {
                setOuputvoltC(
                  getMyValue(res, ["graphData", 0, "output_ph_volt_C"])
                );
              }
              if (res.graphData[0]["output_ph_curr_A"]) {
                setOuputcurrA(
                  getMyValue(res, ["graphData", 0, "output_ph_curr_A"])
                );
              }
              if (res.graphData[0]["output_ph_curr_B"]) {
                setOuputcurrB(
                  getMyValue(res, ["graphData", 0, "output_ph_curr_B"])
                );
              }
              if (res.graphData[0]["output_ph_curr_C"]) {
                setOuputcurrC(
                  getMyValue(res, ["graphData", 0, "output_ph_curr_C"])
                );
              }
            }
          });
        });
      } else {
        api.floor.UpsData(deviceid).then((res) => {
          console.log("upsdata", res);
          res.map((ele) => {
            if (ele.param_id == "input_ph_volt_A") {
              setValue2(ele.param_value);
            }
            if (ele.param_id == "input_ph_volt_B") {
              setValue3(ele.param_value);
            }
            if (ele.param_id == "input_ph_volt_C") {
              setValue4(ele.param_value);
            }
            if (ele.param_id == "ph_A_Out_acti_Pow ") {
              setValue5(ele.param_value);
            }
            if (ele.param_id == "ph_B_Out_acti_Pow ") {
              setValue6(ele.param_value);
            }
            if (ele.param_id == "ph_C_Out_acti_Pow") {
              setValue7(ele.param_value);
            }
            if (ele.param_id == "kW") {
              setValue8(ele.param_value);
            }
            if (ele.param_id == "output_ph_curr_A") {
              setValue9(ele.param_value);
            }
            if (ele.param_id == "output_ph_curr_B") {
              setValue10(ele.param_value);
            }
            if (ele.param_id == "output_ph_curr_C") {
              setValue11(ele.param_value);
            }
            if (ele.param_id == "output_ph_volt_A") {
              setValue12(ele.param_value);
            }
            if (ele.param_id == "output_ph_volt_B") {
              setValue13(ele.param_value);
            }
            if (ele.param_id == "output_ph_volt_C") {
              setValue14(ele.param_value);
            }
            if (ele.param_id == "out_freqphase_A") {
              setValue15(ele.param_value);
            }
            if (ele.param_id == "out_freqphase_B") {
              setValue16(ele.param_value);
            }
            if (ele.param_id == "out_freqphase_C") {
              setValue17(ele.param_value);
            }
            if (ele.param_id == "input_freq") {
              setValue18(ele.param_value);
            }
            if (ele.param_id == "vbat") {
              setValue19(ele.param_value);
            }
            if (ele.param_id == "PF") {
              setValue20(ele.param_value);
            }
            if (ele.param_id == "Runtime") {
              setValue21(ele.param_value);
            }
            setUpsdata2(res);
          });
        });
        console.log("deviceid11111111111111111111111111", deviceid);
        api.floor.UpsGraphData(deviceid).then((res) => {
          if (res.graphData.length) {
            if (res.graphData[0]["output_ph_volt_A"]) {
              setOuputvoltA(
                getMyValue(res, ["graphData", 0, "output_ph_volt_A"])
              );
            }
            if (res.graphData[0]["output_ph_volt_B"]) {
              setOuputvoltB(
                getMyValue(res, ["graphData", 0, "output_ph_volt_B"])
              );
            }
            if (res.graphData[0]["output_ph_volt_C"]) {
              setOuputvoltC(
                getMyValue(res, ["graphData", 0, "output_ph_volt_C"])
              );
            }
            if (res.graphData[0]["output_ph_curr_A"]) {
              setOuputcurrA(
                getMyValue(res, ["graphData", 0, "output_ph_curr_A"])
              );
            }
            if (res.graphData[0]["output_ph_curr_B"]) {
              setOuputcurrB(
                getMyValue(res, ["graphData", 0, "output_ph_curr_B"])
              );
            }
            if (res.graphData[0]["output_ph_curr_C"]) {
              setOuputcurrC(
                getMyValue(res, ["graphData", 0, "output_ph_curr_C"])
              );
            }
          }
        });

        console.log("deviceidddd get ahulasthr", deviceid);
        // api.floor.UpsGraphData(deviceid).then((res) => {
        //   // setUps(res.graphData[0]);
        // })
      }
    });
  }, [buildingID, initialState1, deviceid]);

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <Grid container spacing={1}>
          <Grid container item xs={12} spacing={1}>
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
              <FormControl
                variant="filled"
                size="small"
                style={{
                  width: "max-content",
                  minWidth: "100%",
                  backgroundColor: "#eeeef5",
                }}
              >
                <Select
                  labelId="demo-simple-select-outlined-label"
                  id="demo-simple-select-outlined"
                  label="Floor"
                  className={classes.select}
                  value={fdata}
                  style={{
                    borderRadius: "0.8vw",
                    height: "6vh",
                    fontWeight: "bold",
                  }}
                  disableUnderline
                >
                  {equipmentData
                    .sort((a, b) => {
                      const aNum = parseInt(a.name, 10);
                      const bNum = parseInt(b.name, 10);

                      // If both are numeric, sort numerically (e.g. 1, 2, 10)
                      if (!isNaN(aNum) && !isNaN(bNum)) return aNum - bNum;

                      // Otherwise, sort alphabetically
                      return a.name.localeCompare(b.name, undefined, {
                        numeric: true,
                        sensitivity: "base",
                      });
                    })
                    .map((_item) => (
                      <MenuItem
                        key={_item.name}
                        value={_item.name}
                        onClick={() =>
                          handleDeviceChange(_item.name, _item.id, _item)
                        }
                      >
                        {_item.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid container item xs={12} spacing={1}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
              <Grid container item xs={12} spacing={1}>
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                  <Grid container item xs={12} spacing={1}>
                    <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
                      <Card
                        className={classes.paper}
                        style={{
                          height: "14vh",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Grid
                          container
                          item
                          xs={12}
                          spacing={1}
                          direction="column"
                          alignItems="center"
                        >
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                            xxl={6}
                            style={{ fontSize: "2.5rem" }}
                          >
                            <Success>0</Success>
                          </Grid>
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            md={6}
                            lg={6}
                            xl={6}
                            xxl={6}
                            className={classes.statusFont}
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            Total Alarms
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                   <Grid item xs={12} sm={12} md={3} lg={3} xl={3} xxl={3}>
  <Card
    className={classes.paper}
    style={{
     // boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)",
      backgroundColor: "#fcfafa",
      borderRadius: "10px",
      height: "14vh",
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "flex-start",
      paddingTop: "8px",
    }}
  >
    
  </Card>
</Grid>

                    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} xxl={6}>
                      <Card
                        className={classes.paper}
                        style={{ height: "14vh" }}
                      >
                        <Grid
                          container
                          item
                          xs={12}
                          spacing={1}
                          className={classes.statusFont}
                          alignItems="center"
                          justifyContent="center"
                        >
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <Grid
                              container
                              item
                              xs={12}
                              spacing={1}
                              style={{
                                display: "flex",
                                justifyContent: "center",
                                alignContent: "center",
                              }}
                            >
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                xxl={12}
                              >
                                <div
                                  className={classes.semicircularbar}
                                  style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginLeft: "0vh",
                                    marginTop: "0.7vh",
                                  }}
                                >
                                  <SemiCircleProgressBar
                                    strokeWidth={16}
                                    stroke="#0123B4"
                                    diameter={100}
                                    marginTop={-1}
                                    percentage={
                                      selectedDevData?.Eqp_Attributes?.[
                                        "UPS_BATERRY_%"
                                      ]?.presentValue != null
                                        ? Number(
                                            selectedDevData.Eqp_Attributes[
                                              "UPS_BATERRY_%"
                                            ].presentValue / 1000
                                          ).toFixed(2)
                                        : 0
                                    }
                                    showPercentValue
                                  />
                                </div>
                              </Grid>
                            </Grid>
                            <Grid
                              container
                              item
                              xs={12}
                              spacing={1}
                              alignItems="center"
                              justifyContent="center"
                            >
                              <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                lg={12}
                                xl={12}
                                xxl={12}
                                className={classes.statusFont}
                                style={{
                                  fontWeight: "bold",
                                  whiteSpace: "nowrap",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  textAlign: "center",
                                }}
                              >
                                Battery Charge
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
                            <Card
                              style={{
                                boxShadow:
                                  "inset 0px 0px 0px 2px rgb(76 175 80)",
                                backgroundColor: "#fcfafa",
                                "border-radius": "10px",
                                height: "11.5vh",
                              }}
                            >
                              <Grid
                                container
                                item
                                xs={12}
                                direction="column"
                                style={{
                                  "justify-content": "center",
                                  "align-content": "center",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <Grid
                                  container
                                  item
                                  xs={12}
                                  spacing={1}
                                  direction="column"
                                  alignItems="center"
                                >
                                 
                                  <Grid
                                    item
                                    xs={5}
                                    sm={5}
                                    md={5}
                                    lg={5}
                                    xl={5}
                                    xxl={5}
                                    className={classes.alarms}
                                    style={{
                                      display: "flex",
                                      justifyContent: "center",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    {(() => {
                                      const batteryVoltage =
                                        selectedDevData?.Eqp_Attributes?.[
                                          "UPS_Battery_Volt"
                                        ]?.presentValue;

                                      if (
                                        batteryVoltage === null ||
                                        batteryVoltage === undefined
                                      ) {
                                        return "—";
                                      }

                                      const scaledValue =
                                        parseFloat(batteryVoltage) / 100;

                                      return isNaN(scaledValue)
                                        ? "—"
                                        : scaledValue.toFixed(2);
                                    })()}
                                    V
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Card>
                          </Grid>
                        </Grid>
                      </Card>
                    </Grid>
                  </Grid>
                  

<Grid container item xs={12} spacing={1}>
  <Grid item xs={12} sm={12} md={12} lg={12} xl={12} xxl={12}>
    <Card className={`${classes.paper} ${classes.card1}`}>
      <Grid
        container
        item
        xs={12}
        spacing={1}
        alignItems="center"
        justifyContent="center"
      >
        {/* Load Card */}
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
          <Grid container item xs={12} spacing={1}>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
            >
              <div
                className={classes.semicircularbar}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  marginLeft: "1vh",
                
                  
                }}
              >
                <SemiCircleProgressBar
                  strokeWidth={17}
                  marginTop={-1}
                  stroke="#0123B4"
                  diameter={100}
                  percentage={
                    selectedDevData?.Eqp_Attributes?.[
                      "UPS_O/P_LOAD%"
                    ]?.presentValue != null
                      ? Number(
                          selectedDevData.Eqp_Attributes[
                            "UPS_O/P_LOAD%"
                          ].presentValue / 1000
                        ).toFixed(2)
                      : 0
                  }
                  showPercentValue
                />
              </div>
            </Grid>
          </Grid>
          <Grid
            container
            item
            xs={12}
            spacing={1}
            alignItems="center"
            justifyContent="center"
          >
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className={classes.statusFont}
              style={{
                fontWeight: "bold",
                whiteSpace: "nowrap",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
              }}
            >
              Load
            </Grid>
          </Grid>
        </Grid>

        {/* Temperature Card */}
        <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
          <Card
            style={{
              boxShadow:
                "inset 0px 0px 0px 2px rgb(76 175 80)",
              backgroundColor: "#fcfafa",
              "border-radius": "10px",
              height: "11.5vh",
            }}
          >
            <Grid
              container
              item
              xs={12}
              direction="column"
              style={{
                display: "flex",
                justifyContent: "center",
                whiteSpace: "nowrap",
              }}
            >
              <Grid
                container
                item
                xs={12}
                spacing={1}
                direction="column"
                alignItems="center"
                whiteSpace="nowrap"
              >
                <Grid
                  item
                  xs={1}
                  sm={1}
                  md={1}
                  lg={1}
                  xl={1}
                  xxl={1}
                >
                  {" "}
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={6}
                  md={6}
                  lg={6}
                  xl={6}
                  xxl={6}
                  className={classes.statusFont}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  Temperature
                </Grid>
                <Grid
                  item
                  xs={5}
                  sm={5}
                  md={5}
                  lg={5}
                  xl={5}
                  xxl={5}
                  className={classes.alarms}
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {selectedDevData?.Eqp_Attributes?.[
                    "UPS_Temp"
                  ]?.presentValue != null
                    ? Number(
                        selectedDevData.Eqp_Attributes[
                          "UPS_Temp"
                        ].presentValue / 1000
                      ).toFixed(2)
                    : ""}{" "}
                  °C
                </Grid>
              </Grid>
            </Grid>
          </Card>
        </Grid>
      </Grid>
    </Card>
  </Grid>
</Grid>
                </Grid>
                <Grid
  item
  xs={12}
  sm={12}
  md={6}
  lg={6}
  xl={6}
  xxl={6}
  spacing={1}
>
  <Card className={classes.paper} style={{ height: "29.5vh" }}>
    <Grid container item xs={12} spacing={2}>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
        <Card
          style={{
            boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)",
            backgroundColor: "#fcfafa",
            "border-radius": "10px",
            height: "11.5vh",
          }}
        >
          <Grid
            container
            item
            xs={12}
            direction="column"
            style={{
              "justify-content": "center",
              "align-content": "center",
              whiteSpace: "nowrap",
            }}
          >
            <Grid
              container
              item
              xs={12}
              spacing={1}
              direction="column"
              alignItems="center"
            >
              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                lg={1}
                xl={1}
                xxl={1}
              >
                {" "}
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className={classes.statusFont}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Input Voltage
              </Grid>
              <Grid
                item
                xs={5}
                sm={5}
                md={5}
                lg={5}
                xl={5}
                xxl={5}
                className={classes.alarms}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {selectedDevData?.Eqp_Attributes?.[
                  "UPS_I/P_VOLTAGE"
                ]?.presentValue != null
                  ? Number(
                      selectedDevData.Eqp_Attributes[
                        "UPS_I/P_VOLTAGE"
                      ].presentValue / 100
                    ).toFixed(2)
                  : "—"}{" "}
                V
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
        <Card
          style={{
            boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)",
            backgroundColor: "#fcfafa",
            "border-radius": "10px",
            height: "11.5vh",
          }}
        >
          <Grid
            container
            item
            xs={12}
            direction="column"
            style={{
              "justify-content": "center",
              "align-content": "center",
              whiteSpace: "nowrap",
            }}
          >
            <Grid
              container
              item
              xs={12}
              spacing={1}
              direction="column"
              alignItems="center"
            >
              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                lg={1}
                xl={1}
                xxl={1}
              >
                {" "}
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className={classes.statusFont}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Output Voltage
              </Grid>
              <Grid
                item
                xs={5}
                sm={5}
                md={5}
                lg={5}
                xl={5}
                xxl={5}
                className={classes.alarms}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {selectedDevData?.Eqp_Attributes?.[
                  "UPS_O/P_Volt"
                ]?.presentValue != null
                  ? Number(
                      selectedDevData.Eqp_Attributes[
                        "UPS_O/P_Volt"
                      ].presentValue / 100
                    ).toFixed(2)
                  : "—"}{" "}
                V
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} xxl={4}>
        <Card
          style={{
            boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)",
            backgroundColor: "#fcfafa",
            "border-radius": "10px",
            height: "11.5vh",
          }}
        >
          <Grid
            container
            item
            xs={12}
            direction="column"
            style={{
              "justify-content": "center",
              "align-content": "center",
              whiteSpace: "nowrap",
            }}
          >
            <Grid
              container
              item
              xs={12}
              spacing={1}
              direction="column"
              alignItems="center"
            >
              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                lg={1}
                xl={1}
                xxl={1}
              >
                {" "}
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={6}
                lg={6}
                xl={6}
                xxl={6}
                className={classes.statusFont}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Input Frequency
              </Grid>
              <Grid
                item
                xs={5}
                sm={5}
                md={5}
                lg={5}
                xl={5}
                xxl={5}
                className={classes.alarms}
                style={{
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                {selectedDevData?.Eqp_Attributes?.[
                  "UPS_I/P_FREQUINCY"
                ]?.presentValue != null
                  ? Number(
                      selectedDevData.Eqp_Attributes[
                        "UPS_I/P_FREQUINCY"
                      ].presentValue / 1000
                    ).toFixed(2)
                  : "—"}{" "}
                Hz
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
  <Card
    style={{
      boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)",
      backgroundColor: "#fcfafa",
      "border-radius": "10px",
      height: "11.5vh",
    }}
  >
    <Grid
      container
      item
      xs={12}
      direction="column"
      style={{
        "justify-content": "center",
        "align-content": "center",
        whiteSpace: "nowrap",
      }}
    >
      <Grid
        container
        item
        xs={12}
        spacing={1}
        direction="column"
        alignItems="center"
      >
        <Grid
          item
          xs={1}
          sm={1}
          md={1}
          lg={1}
          xl={1}
          xxl={1}
        >
          {" "}
        </Grid>
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          xxl={6}
          className={classes.statusFont}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          Output Frequency
        </Grid>
        <Grid
          item
          xs={5}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          xxl={5}
          className={classes.alarms}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {selectedDevData?.Eqp_Attributes?.[
            "UPS_I/P_FREQUINCY"
          ]?.presentValue != null
            ? Number(
                selectedDevData.Eqp_Attributes[
                  "UPS_I/P_FREQUINCY"
                ].presentValue / 100
              ).toFixed(2)
            : ""}{" "}
          Hz
        </Grid>
      </Grid>
    </Grid>
  </Card>
</Grid>
<Grid item xs={6} sm={6} md={6} lg={6} xl={6} xxl={6}>
  <Card
    style={{
      boxShadow: "inset 0px 0px 0px 2px rgb(76 175 80)",
      backgroundColor: "#fcfafa",
      "border-radius": "10px",
      height: "11.5vh",
    }}
  >
    <Grid
      container
      item
      xs={12}
      direction="column"
      style={{
        "justify-content": "center",
        "align-content": "center",
        whiteSpace: "nowrap",
      }}
    >
      <Grid
        container
        item
        xs={12}
        spacing={1}
        direction="column"
        alignItems="center"
      >
        <Grid
          item
          xs={1}
          sm={1}
          md={1}
          lg={1}
          xl={1}
          xxl={1}
        >
          {" "}
        </Grid>
        <Grid
          item
          xs={6}
          sm={6}
          md={6}
          lg={6}
          xl={6}
          xxl={6}
          className={classes.statusFont}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          Output Current
        </Grid>
        <Grid
          item
          xs={5}
          sm={5}
          md={5}
          lg={5}
          xl={5}
          xxl={5}
          className={classes.alarms}
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          {selectedDevData?.Eqp_Attributes?.[
            "UPS_O/P_Current"
          ]?.presentValue != null
            ? Number(
                selectedDevData.Eqp_Attributes[
                  "UPS_O/P_Current"
                ].presentValue / 100
              ).toFixed(2)
            : "—"}{" "}
          A
        </Grid>
      </Grid>
    </Grid>
  </Card>
</Grid>
    </Grid>
  </Card>
</Grid>
              </Grid>
              <Grid container item xs={12} spacing={1}>
                
                 <Grid item xs={12} sm={12} md={4} lg={4} xl={4} xxl={4}>
                  <Card className={classes.paper} style={{ height: "49vh" }}>
                    <img
                      className={classes.image}
                      src={Ups}
                      alt="UPS"
                      style={{
                        width: "40vh",
                        height: "40vh",
                        marginTop: "4vh",
                        opacity: "2",
                      }}
                    />
                  </Card>
                </Grid>

                {/* RIGHT SIDE - VOLTAGE GRID */}
                
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ThemeProvider>
    </div>
  );
}
